import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';

import TimeService from 'dashboard-services/services/TimeService';

import { STEPS } from '../constants';

import classNames from 'classnames';
import './Header.scss';

const minuteToReadable = minute => {
  if(String(minute).indexOf("/") > -1) {
    if(minute.slice(2) === "1") {
      return "every minute"
    }
    return `every ${minute.slice(2)} minutes`
  } else {
    return minute
  }
}

const hourToReadable = hour => {
  if(String(hour).indexOf("/") > -1) {
    if(hour.slice(2) === "1") {
      return "every hour"
    }
    return `every ${hour.slice(2)} hours`
  } else if(hour === "*") {
    return "every hour"
  }
  return hour;
}

const daysToReadable = (dayOfWeek, dayOfMonth) => {
  if(dayOfMonth === "*" || dayOfWeek === "*") {
    return "every day";
  }
  if(dayOfWeek !== "?" && dayOfWeek !== "") {
    const days = []
    dayOfWeek.split(",").forEach(text => days.push(TimeService.getWeekDay(text)))
    return days.join(", ")
  }
  if(dayOfMonth === "?") {
    return ""
  }
  return dayOfMonth
}

const Header = ({ hour = "", minute = "", dayOfMonth = "", dayOfWeek = "", setActiveStep, activeStep = undefined }) => {
  const activateHours = useCallback(() => setActiveStep(STEPS.HOUR), [setActiveStep]),
        activateMinutes = useCallback(() => setActiveStep(STEPS.MINUTE), [setActiveStep]),
        activateDays = useCallback(() => setActiveStep(STEPS.DAY), [setActiveStep])

  return (
    <div className="cron-creator__header">
      <div className="cron-creator__header__label">
        Execute at
      </div>
      <div className="cron-creator__header__box">
        <div className="cron-creator__header__box__label">
          Hours
        </div>
        <div 
            className={classNames(
              "cron-creator__header__box__value",
              { "cron-creator__header__box__value--is-active": activeStep === STEPS.HOUR }
            )}
            onClick={activateHours}
        >
          <div className="cron-creator__header__box__value__fake-input"><p>{hourToReadable(hour)}</p></div>
        </div>
      </div>
      <div className="cron-creator__header__box">
        <div className="cron-creator__header__box__label">
          Minutes
        </div>
        <div 
            className={classNames(
              "cron-creator__header__box__value",
              { "cron-creator__header__box__value--is-active": activeStep === STEPS.MINUTE }
            )}
            onClick={activateMinutes}
        >
          <div className="cron-creator__header__box__value__fake-input"><p>{minuteToReadable(minute)}</p></div>
        </div>
      </div>
      <div className="cron-creator__header__box">
        <div className="cron-creator__header__box__label">
          Days
        </div>
        <div 
            className={classNames(
              "cron-creator__header__box__value",
              { "cron-creator__header__box__value--is-active": activeStep === STEPS.DAY }
            )}
            onClick={activateDays}
        >
          <div className="cron-creator__header__box__value__fake-input cron-creator__header__box__value__fake-input--is-large"><p>{daysToReadable(dayOfWeek, dayOfMonth)}</p></div>
        </div>
      </div>
    </div>
  )
}

Header.propTypes = {
  activeStep: PropTypes.string,
  dayOfMonth: PropTypes.string,
  dayOfWeek: PropTypes.string,
  hour: PropTypes.string,
  minute: PropTypes.string,
  setActiveStep: PropTypes.func.isRequired,
}

export default memo(Header)